<template>
    <div v-bind:style="styles" id="Pgwrp" ref="Pgwrp">
      <div id="page-content" v-if="!viLoader">
        <div class="row mt-4" style="margin-left: 1%; margin-right: 1%">
          <div class="col-sm-12 col-lg-6" style="margin-top: 2%">
            <div class="white-box org mb-2" @click.prevent="redirectRoute(`/parent/student/portal/view/details/${$route.params.id}`)">
              <div class="no-org no-cirlce">
               View
              </div>
              <p class="widgettitle m-0">
                <span>Student Profile</span>
              </p>
            </div>
          </div>
           <div class="col-sm-12 col-lg-6" style="margin-top: 2%">
            <div class="white-box blu mb-2" @click.prevent="redirectRoute(`/parent/student/feePayment/${$route.params.id}`)">
              <div class="no-blu no-cirlce">
                View
              </div>
              <p class="widgettitle m-0">
                <span>Fee Payment</span>
              </p>
            </div>
          </div>
          <div class="col-sm-12 col-lg-6" style="margin-top: 2%">
            <div class="white-box blu mb-2" @click.prevent="redirectRoute(`/parent/student/alerts/${$route.params.id}`)">
              <div class="no-blu no-cirlce">
                {{ alertList.length }}
              </div>
              <p class="widgettitle m-0">
                <span>Alerts & Notifications</span>
              </p>
            </div>
          </div>
          <div class="col-sm-12 col-lg-6" style="margin-top: 2%">
            <div class="white-box blu mb-2" @click.prevent="redirectRoute(`/parent/student/tc/${$route.params.id}`)">
              <div class="no-blu no-cirlce">
                {{ onlineAdmissionCount }}
              </div>
              <p class="widgettitle m-0">
                <span>Certificate Request</span>
              </p>
            </div>
          </div>
         
        </div>
        
        
      </div>
       <vi-spinner
                v-if="viLoader"
                text="Loading..."
                textColor="vi-brand-color"
                class="flex-fill h-100 vi-fs12"
                style="width: 100%;z-index: 111;top:0;left:0;background-color: rgba(255, 255, 255, 0.5);border-radius: 1rem;"
              />
    </div>
    
</template>
<script>
import ViSpinner from "../Common/ViSpinner";
import ViService from "@/services/ViService";
import errorLog from "@/utils/errorLog";
import secureUI from "../../utils/secureUI";
import VueMonthlyPicker from "vue-monthly-picker";
import NavBar from "@/views/ViNavBar.vue";

export default {
  name: "vi-parent-home",

  data() {
    return {
      viLoader: false,
      showToast: false,
      count: {
        academicYear: 0,
        admission: 0,
        class: 0,
        departMent: 0,
        student: 0,
        teacher: 0,
      },
      studentInformation: [],
      onlineAdmissionCount: 0,
      alertList: []
    };
  },
  computed: {
    styles() {
      var brwHeight = window.innerHeight;
      return {
        height: brwHeight - 90 + "px",
      };
    },
  
  },
  created() {
    this.getOnlineTc()
    this.getAlertList()
  },
  methods: {
    redirectRoute(vipath) {
      localStorage.setItem("activeTab",vipath);
      if (this.$route.path !== vipath) this.$router.push({ path: vipath });
    },
    	async getOnlineTc() {
      let userData = secureUI.sessionGet("user");

      if (!userData) {
        this.$toasted.error("Please login and do the action");
        this.$router.push('/login');
      } else {
        this.viLoader = true
        const response = await ViService.viXGet(`/contact/getOnlineCertificateRequestDetails?studentId=${this.$route.params.id}`,userData.token);
     
	     if (response.isSuccess) {
        const onlineTcDetails = secureUI.secureGet(response.data);
        this.onlineAdmissionCount = onlineTcDetails.requestList.length || 0

		
			
        } else {
          this.$toasted.error(response.message);
           if(response.message == 'Your session has expired, please login'){
                localStorage.removeItem('user');
                this.$router.push('/login');
         }
        }
        this.viLoader = false
      }
    },
    viewStudentProfileAndPayemnt(studentId) {
      if (studentId) {
        this.$router.push(`/parent/student/portal/view/details/${studentId}`);
      }
    },
     async getAlertList() {
      let userData = secureUI.sessionGet("user");

      if (!userData) {
        this.$toasted.error("Please login and do the action");
        this.$router.push('/login');
      } else {
        const response = await ViService.viXGet(`/contact/getalertListForstudent?studentId=${this.$route.params.id}`,userData.token);

        if (response.isSuccess) {
          this.alertList = secureUI.secureGet(response.data);
        } else {
          this.$toasted.error(response.message);
           if(response.message == 'Your session has expired, please login'){
                localStorage.removeItem('user');
                this.$router.push('/login');
         }
        }

      }
    },

    getStudentForParent() {
      let userData = secureUI.sessionGet("user");

      ViService.viXGet(
        "/contact/getStudentAndSchoolDetails/parent/portal",
        userData.token
      )
        .then((res) => {
          if (res.isSuccess) {
            let data = secureUI.secureGet(res.data);
            if (res.data) {
              this.studentInformation = data;
            }
          } else {
            this.$toasted.show(res.message);
            if(res.message == 'Your session has expired, please login'){
                localStorage.removeItem('user');
                this.$router.push('/login');
              }
          }
        })
        .catch((e) => {
          let eData = errorLog.apiErrorLog(e);
          this.$toasted.error(eData);
        });
    },
  },
  components: {
    ViSpinner
  }
};
</script>

<style lang="scss" scoped></style>